'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignOptions", "alignment", "defaultAlignment", "onChange"];
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import UITextToolbarIconDropdown from '../editor/UITextToolbarIconDropdown';
import { AlignmentIconMap } from '../../constants/alignments';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_PREFIX = 'align';
const getIconName = icon => `${ICON_PREFIX}${icon.charAt(0).toUpperCase()}${icon.slice(1)}`;
const getOptions = alignOptions => Object.keys(alignOptions).map(key => ({
  icon: getIconName(alignOptions[key]),
  value: alignOptions[key],
  Icon: AlignmentIconMap[alignOptions[key]]
}));

// @TODO: Remove this component in favor of `AlignmentDropdown` -- they're functionally identical
//  and less opinionatedregarding the Icon and options
export default function AlignmentMenu(props) {
  const {
      alignOptions,
      alignment,
      defaultAlignment,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleAlignmentClick = ({
    currentTarget: {
      value
    }
  }) => {
    onChange(value);
  };
  const options = useMemo(() => getOptions(alignOptions), [alignOptions]);
  return /*#__PURE__*/_jsx(UITextToolbarIconDropdown, Object.assign({}, rest, {
    defaultValue: defaultAlignment,
    onChange: handleAlignmentClick,
    options: options,
    value: alignment
  }));
}
AlignmentMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultAlignment: PropTypes.string.isRequired,
  alignment: PropTypes.string,
  alignOptions: PropTypes.object.isRequired
};